import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'react-autocomplete';
import Highlighter from 'react-highlight-words';
import classnames from 'classnames';
import _delay from 'lodash/delay';
import onClickOutside from 'react-onclickoutside';
import TextCropper from '@omilia/text-cropper';

import { projectType, contextType } from 'types';
import Spinner from 'components/Spinner';
import './style.scss';

export class ContextsMenuOptions extends Component {
  static propTypes = {
    changeValue: PropTypes.func.isRequired,
    closePanel: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(projectType).isRequired,
    selectItem: PropTypes.func.isRequired,
    currentContext: contextType,
    isLoading: PropTypes.bool,
    value: PropTypes.string,
  };

  componentDidMount() {
    if (this.input) {
      this.input.focus();
    }
  }

  matchItemToTerm = (item, value) => {
    if (value === '') {
      return true;
    }

    return item.name.toLowerCase().includes(value.toLowerCase());
  };

  handleClickOutside = () => {
    const { closePanel } = this.props;
    closePanel();
  };

  handleKeyUp = async e => {
    const key = e.which;

    if (key === 27) {
      const { value, changeValue, closePanel } = this.props;

      if (value) {
        await changeValue('');
        _delay(() => {
          this.input.focus();
        }, 100);
      } else {
        closePanel();
      }
    }
  };

  renderNoItems = () => {
    const { isLoading } = this.props;
    if (isLoading) {
      return null;
    }

    return <span styleName="item no-items">No contexts found</span>;
  };

  render() {
    const {
      items,
      value,
      isLoading,
      currentContext,
      selectItem,
      changeValue,
    } = this.props;
    return (
      <AutoComplete
        ref={el => {
          this.input = el;
        }}
        autoHighlight
        open
        getItemValue={item => item.name}
        items={items}
        renderInput={props => (
          <div styleName="search-container">
            <input
              data-test="search-input"
              placeholder="Select a context"
              styleName="input"
              onKeyUp={this.handleKeyUp}
              {...props}
            />
            {isLoading && <Spinner isBlue styleName="spinner" />}
          </div>
        )}
        renderItem={item => (
          <div
            key={item.id}
            styleName={classnames('item', {
              'is-active': currentContext.id === item.id,
              'is-archived': item.archived,
            })}
          >
            <TextCropper placement="right" styleName="cropper" text={item.name}>
              <Highlighter
                autoEscape
                highlightStyle={{
                  borderBottom: '1px solid #0A0A0A',
                }}
                searchWords={[value]}
                textToHighlight={item.name}
              />
            </TextCropper>
          </div>
        )}
        renderMenu={children => (
          <div styleName="menu">
            {children.length > 0 ? children : this.renderNoItems()}
          </div>
        )}
        shouldItemRender={this.matchItemToTerm}
        value={value}
        wrapperStyle={{ display: 'block' }}
        onChange={(event, value) => {
          if (!items.find(item => item.name === value)?.archived) {
            changeValue(value);
          }
        }}
        onSelect={(value, item) => {
          if (!item.archived) {
            selectItem(item);
          }
        }}
      />
    );
  }
}

export default onClickOutside(ContextsMenuOptions);
